(() => {
  if (window.treviCatalogTabs) return;
  window.treviCatalogTabs = true;
  let category = location.pathname.split('/').slice(0,3).join('/');
  let controller;
  const flavors = new Set((new URL(location.href).searchParams.get('flavors') || location.pathname.split('/')[3] || '').split(',').filter(Boolean));
  document.querySelectorAll('[data-trevi-flavor]').forEach(input => input.checked = flavors.has(input.value));
  const load = async () => {
    controller?.abort();
    const request = controller = new AbortController();
    const target = document.querySelector('.Collection-products');
    const sort = document.querySelector('.js-collections-filter-drawer input:checked')?.id || 'manual';
    target.setAttribute('aria-busy','true');
    try {
      const fetchPage = async path => {
        const url = new URL(path, location.origin);
        url.searchParams.set('sort_by',sort);
        const response = await fetch(url, {signal:request.signal});
        if (!response.ok) throw Error('Unable to load products');
        return new DOMParser().parseFromString(await response.text(),'text/html');
      };
      const pages = await Promise.all([...flavors].map(async flavor => {
        let page = await fetchPage(`${category}/${flavor}`);
        const first = page;
        let next = page.querySelector('#Collection-ajaxinate-pagination a[rel=next]');
        while (next) {
          page = await fetchPage(next.href);
          first.querySelector('#Collection-ajaxinate').append(...page.querySelectorAll('#Collection-ajaxinate > .Grid-item'));
          next = page.querySelector('#Collection-ajaxinate-pagination a[rel=next]');
        }
        return first;
      }));
      if (!pages.length) pages.push(await fetchPage(category));
      const content = pages[0].querySelector('.Collection-products');
      if (flavors.size) {
        const seen = new Set();
        const cards = pages.flatMap(page => [...page.querySelectorAll('#Collection-ajaxinate > .Grid-item')]).filter(card => {
          const key = card.querySelector('.ProductCard-image-link')?.getAttribute('href') || card.querySelector('.ProductCard')?.className;
          if (seen.has(key)) return false;
          seen.add(key); return true;
        });
        if (sort === 'price-ascending' || sort === 'price-descending') cards.sort((a,b) => (Number(a.dataset.catalogPrice)-Number(b.dataset.catalogPrice))*(sort === 'price-ascending'?1:-1));
        if (sort === 'created-descending') cards.sort((a,b)=>Number(b.dataset.catalogCreated)-Number(a.dataset.catalogCreated));
        content.querySelector('#Collection-ajaxinate').replaceChildren(...cards);
        content.querySelector('.Pagination')?.remove();
        if (!cards.length) content.textContent = 'No products match these flavors in this category.';
      }
      target.replaceChildren(...content.childNodes);
      const state = new URL(location.href);
      state.pathname = '/collections/shop-all-copy';
      state.searchParams.set('category',category);
      state.searchParams.set('sort_by',sort);
      if (flavors.size) state.searchParams.set('flavors',[...flavors].join(',')); else state.searchParams.delete('flavors');
      history.replaceState({},'',state);
      document.querySelector('.js-collections-filter-drawer')?.classList.remove('expanded');
      document.querySelector('.js-collections-filter-toggle')?.classList.remove('opened');
    } catch(error) {
      if (error.name !== 'AbortError') target.setAttribute('data-load-error','true');
    } finally { if (controller === request) target.removeAttribute('aria-busy'); }
  };
  document.addEventListener('change',event => {
    if (!event.target.matches('[data-trevi-flavor]')) return;
    if (event.target.checked) flavors.add(event.target.value); else flavors.delete(event.target.value);
    load();
  });
  document.addEventListener('click',event => {
    const tab = event.target.closest('[data-trevi-catalog-tabs] a');
    if (tab?.hasAttribute('data-landing-page')) return;
    const sort = event.target.closest('.js-apply-filter');
    const clear = event.target.closest('[data-trevi-clear-flavors]');
    if ((!tab && !sort && !clear) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (tab) {category = new URL(tab.href).pathname;document.querySelectorAll('[data-trevi-catalog-tabs] a').forEach(link=>link.setAttribute('aria-current',String(link === tab)));}
    if (clear) {flavors.clear();document.querySelectorAll('[data-trevi-flavor]').forEach(input=>input.checked=false);}
    load();
  },true);
  const savedCategory = new URL(location.href).searchParams.get('category');
  if (savedCategory && [...document.querySelectorAll('[data-trevi-catalog-tabs] a:not([data-landing-page])')].some(link => new URL(link.href).pathname === savedCategory)) {
    category = savedCategory;
    document.querySelectorAll('[data-trevi-catalog-tabs] a').forEach(link => link.setAttribute('aria-current', String(new URL(link.href).pathname === category)));
  }
  if (flavors.size || savedCategory) load();
})();

// Keep full flavor names on one line, including longer special editions.
(() => {
  const fitLabels = () => {
    const base = matchMedia('(max-width:749px)').matches ? 13.2 : 16.8;
    document.querySelectorAll('.trevi-catalog-product-details .ProductCard-title').forEach(label => {
      label.style.fontSize = `${base}px`;
      if (label.clientWidth && label.scrollWidth > label.clientWidth) {
        label.style.fontSize = `${Math.floor(base * label.clientWidth / label.scrollWidth * 100) / 100}px`;
      }
    });
  };
  const observer = new MutationObserver(fitLabels);
  const products = document.querySelector('.Collection-products');
  if (products) observer.observe(products, {childList:true, subtree:true});
  window.addEventListener('resize', fitLabels);
  document.fonts.ready.then(fitLabels);
  fitLabels();
})();
